import { LOGOUT } from "./types";
import axios from 'axios';

export function logoutUser() {
  return (dispatch) => {
    dispatch({ type: LOGOUT })
  };
}